import EventsSection from '../../homepage/homepage_components/events/event';

export default function EventsPage() {
  return (
    <div>   
      <EventsSection />
    </div>
  );
}